<template>
  <v-form ref="form" @submit.prevent="$emit('submit')">
    <v-row>
      <v-col>
        <h4>General information</h4>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="resultApiUserUsername"
        >
          <v-text-field
            v-model.trim="user.username"
            label="Username"
            name="username"
            :error-messages="errors"
            type="text"
          >
          </v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="password"
        >
          <v-text-field
            v-model.trim="user.password"
            label="Password"
            name="password"
            :error-messages="errors"
            type="text"
          >
          </v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="resultApiUserDomain"
        >
          <v-text-field
            v-model.trim="user.domain"
            label="Domain"
            name="domain"
            :error-messages="errors"
            type="text"
          >
          </v-text-field>
        </validation-provider>

        <validation-provider
          v-if="!isUpdate"
          v-slot:="{ errors }"
          rules="required"
          slim
          name="serverId"
        >
          <v-select
            v-model="user.serverId"
            :items="params.servers"
            item-value="id"
            item-text="domain"
            label="Servers"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <input type="submit" hidden />
  </v-form>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules.js";

extend("required", {
  ...required,
  message: "This field is required"
});

export default {
  name: "ResultUserApiForm",
  components: {
    ValidationProvider
  },
  model: {
    prop: "user"
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
      description: "The user to be manipulated."
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped></style>
